import { LOGOUT_SUCCESS } from "../Login/loginConstants";
import { IUserAchievementSummary } from "./achievements.t";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAchievementsState {
    achievements: IUserAchievementSummary[],
    achievementsError: string,
    achievementsIsLoading: boolean,
    achievementsPreview: IUserAchievementSummary[],
    achievementsPreviewError: string,
    achievementsPreviewIsLoading: boolean,
    achievementsProgress: IUserAchievementSummary[],
    achievementsProgressError: string,
    achievementsProgressIsLoading: boolean,
}

const initialState: IAchievementsState = {
    achievements: [],
    achievementsError: '',
    achievementsIsLoading: false,
    achievementsPreview: [],
    achievementsPreviewError: '',
    achievementsPreviewIsLoading: false,
    achievementsProgress: [],
    achievementsProgressError: '',
    achievementsProgressIsLoading: false,
}
const achievementsSlice = createSlice({
    name: 'achievements',
    initialState,
    reducers: {
        getAchievementsAction: (state, action: PayloadAction) => {
            state.achievementsIsLoading = true;
            state.achievementsError = '';
        },
        getAchievementsSuccess: (state, action: PayloadAction<IUserAchievementSummary[]>) => {
            state.achievements = action.payload;
            state.achievementsIsLoading = false;
        },
        getAchievementsFailure: (state, action: PayloadAction<string>) => {
            state.achievementsError = action.payload;
            state.achievementsIsLoading = false;
        },
        getAchievementsPreviewAction: (state, action: PayloadAction) => {
            state.achievementsPreviewIsLoading = true;
            state.achievementsPreviewError = '';
        },
        getAchievementsPreviewSuccess: (state, action: PayloadAction<IUserAchievementSummary[]>) => {
            state.achievementsPreview = action.payload;
            state.achievementsPreviewIsLoading = false;
        },
        getAchievementsPreviewFailure: (state, action: PayloadAction<string>) => {
            state.achievementsPreviewError = action.payload;
            state.achievementsPreviewIsLoading = false;
        },
        getAchievementsProgressAction: (state, action: PayloadAction) => {
            state.achievementsProgressIsLoading = true;
            state.achievementsProgressError = '';
        },
        getAchievementsProgressSuccess: (state, action: PayloadAction<IUserAchievementSummary[]>) => {
            state.achievementsProgress = action.payload;
            state.achievementsProgressIsLoading = false;
        },
        getAchievementsProgressFailure: (state, action: PayloadAction<string>) => {
            state.achievementsProgressError = action.payload;
            state.achievementsProgressIsLoading = false;
        },
        updateAchievementAction: (state, action: PayloadAction<IUserAchievementSummary>) => {
            const achievementIndex = state.achievements.findIndex((achievement) => achievement.achievement_name === action.payload.achievement_name);
            if (achievementIndex !== -1) {
                state.achievements[achievementIndex] = {
                    ...state.achievements[achievementIndex],
                    ...action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            return {
                ...initialState,
            }
        })
    },
});

export const {
    getAchievementsAction,
    getAchievementsSuccess,
    getAchievementsFailure,
    getAchievementsPreviewAction,
    getAchievementsPreviewSuccess,
    getAchievementsPreviewFailure,
    getAchievementsProgressAction,
    getAchievementsProgressSuccess,
    getAchievementsProgressFailure,
    updateAchievementAction,
} = achievementsSlice.actions;

export default achievementsSlice.reducer;
